export interface QuickNews {
  time: string;
  category: string;
  title: string;
  digest: string;
  hot: number;
}

export const quickNews: QuickNews[] = [
  {
    time: '09-08 22:14',
    category: '热榜',
    title: '「海角编辑部」本周吃瓜榜单出炉',
    digest: '本周十大热门话题盘点，圈内关注度曲线与讨论热度一图看懂。',
    hot: 982,
  },
  {
    time: '09-08 19:40',
    category: '现场',
    title: '新手通道今日答疑汇总',
    digest: '整理近期新瓜友最关心的几个问题，作为入门资料持续更新。',
    hot: 731,
  },
  {
    time: '09-08 16:05',
    category: '攻略',
    title: '「怎么玩」三步上手包已更新',
    digest: '从注册到第一条吃瓜记录，逐步截图版教学已同步到教程合集。',
    hot: 640,
  },
  {
    time: '09-08 12:30',
    category: '规则',
    title: '吃瓜行为守则补充说明发布',
    digest: '针对转载来源与证据标注的两条细则补充，新老用户均需留意。',
    hot: 512,
  },
];

export interface GuideCard {
  tag: string;
  title: string;
  desc: string;
  read: string;
  cover: string;
}

export const guideCollection: GuideCard[] = [
  {
    tag: '入门',
    title: '海角吃瓜入门指南',
    desc: '用一页纸讲清楚海角吃瓜怎么玩，从界面到核心功能全部拆解。',
    read: '约 8 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%2C%20a%20warm%20cream%20paper%20background%20with%20a%20large%20watermelon%20slice%20as%20central%20motif%2C%20surrounded%20by%20floating%20speech%20bubbles%20and%20chat%20notes%2C%20flat%20vector%20style%20with%20smooth%20gradients%2C%20color%20palette%20of%20deep%20green%20and%20vivid%20coral%20orange%20and%20warm%20amber%2C%20soft%20shadows%2C%20clean%20composition%2C%20premium%20print%20aesthetic%2C%20no%20text&width=1200&height=840&seq=guide-intro-01&orientation=landscape',
  },
  {
    tag: '进阶',
    title: '吃瓜线索追踪技巧',
    desc: '从一条线索顺藤摸瓜，学会串联多源信息、交叉核对时间线。',
    read: '约 12 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%2C%20warm%20cream%20paper%20background%20with%20a%20magnifying%20glass%20and%20interconnected%20thread%20lines%20connecting%20small%20chat%20bubble%20notes%2C%20flat%20vector%20style%20with%20smooth%20gradients%2C%20deep%20green%20and%20coral%20orange%20and%20warm%20amber%20palette%2C%20soft%20shadows%2C%20clean%20editorial%20composition%2C%20no%20text&width=1200&height=840&seq=guide-tip-02&orientation=landscape',
  },
  {
    tag: '干货',
    title: '吃瓜避坑自查表',
    desc: '信源分级、情绪化判断、断章取义三连问，理性吃瓜的一手清单。',
    read: '约 6 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%2C%20warm%20cream%20paper%20background%20with%20a%20checklist%20clipboard%20and%20small%20shield%20and%20exclamation%20marks%2C%20flat%20vector%20style%20with%20smooth%20gradients%2C%20deep%20green%20and%20coral%20orange%20and%20warm%20amber%20palette%2C%20soft%20shadows%2C%20clean%20editorial%20composition%2C%20no%20text&width=1200&height=840&seq=guide-avoid-03&orientation=landscape',
  },
  {
    tag: '话题',
    title: '围观点赞的打开方式',
    desc: '如何优雅围观不踩线，把「吃瓜」变成有温度有边界的社交动作。',
    read: '约 9 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%2C%20warm%20cream%20paper%20background%20with%20a%20group%20of%20people%20silhouettes%20gathering%20around%20a%20giant%20cup%20with%20thumbs%20up%20and%20heart%20icons%20floating%20above%2C%20flat%20vector%20style%20with%20smooth%20gradients%2C%20deep%20green%20and%20coral%20orange%20and%20warm%20amber%20palette%2C%20soft%20shadows%2C%20clean%20editorial%20composition%2C%20no%20text&width=1200&height=840&seq=guide-social-04&orientation=landscape',
  },
  {
    tag: '功能',
    title: '订阅与收藏使用手册',
    desc: '用好关注列表与收藏夹，让感兴趣的话题不遗漏，主动而非被动吃瓜。',
    read: '约 7 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%2C%20warm%20cream%20paper%20background%20with%20bookmarks%20and%20bell%20notification%20icons%20arranged%20around%20a%20central%20star%2C%20flat%20vector%20style%20with%20smooth%20gradients%2C%20deep%20green%20and%20coral%20orange%20and%20warm%20amber%20palette%2C%20soft%20shadows%2C%20clean%20editorial%20composition%2C%20no%20text&width=1200&height=840&seq=guide-bookmark-05&orientation=landscape',
  },
  {
    tag: '答疑',
    title: '新老用户高频问答合集',
    desc: '把被问最多的问题收进一册，随查随看，是规则与技巧的补充阅读。',
    read: '约 10 分钟',
    cover:
      'https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20illustration%2C%20warm%20cream%20paper%20background%20with%20a%20big%20question%20mark%20and%20small%20dotted%20lines%20and%20sparkle%20stars%2C%20flat%20vector%20style%20with%20smooth%20gradients%2C%20deep%20green%20and%20coral%20orange%20and%20warm%20amber%20palette%2C%20soft%20shadows%2C%20clean%20editorial%20composition%2C%20no%20text&width=1200&height=840&seq=guide-faq-06&orientation=landscape',
  },
];

export interface TipItem {
  icon: string;
  title: string;
  desc: string;
}

export const tipItems: TipItem[] = [
  {
    icon: 'ri-vip-crown-line',
    title: '先看信源，再看观点',
    desc: '任何信息先定位原始出处，再决定要不要采信，能少踩很多坑。',
  },
  {
    icon: 'ri-time-line',
    title: '保持时间线敏感',
    desc: '把事件放回时间轴里看，很多看似矛盾的信息其实是顺序问题。',
  },
  {
    icon: 'ri-bookmark-line',
    title: '善用收藏攒档案',
    desc: '随手收藏、定期复盘，久了会沉淀出属于你自己的吃瓜素材库。',
  },
  {
    icon: 'ri-group-line',
    title: '少争论，多观察',
    desc: '围观的核心是获得视角，而不是说服别人，留点余地给彼此。',
  },
];

export interface StepItem {
  no: string;
  title: string;
  desc: string;
}

export const startSteps: StepItem[] = [
  {
    no: '01',
    title: '认清边界',
    desc: '先读一遍海角吃瓜规则，明白哪些可聊、哪些不该碰，心里有杆秤。',
  },
  {
    no: '02',
    title: '锁定兴趣',
    desc: '从热榜与索引频道里挑你真正在意的几个方向，先订阅、后深入。',
  },
  {
    no: '03',
    title: '跟一条线',
    desc: '挑一个话题全程跟踪，配合线索追踪技巧，练出完整的观察思路。',
  },
];

export interface RuleItem {
  key: string;
  title: string;
  desc: string;
}

export const ruleItems: RuleItem[] = [
  {
    key: 'R01',
    title: '转载要注明来源',
    desc: '引用他人内容请保留出处，标注时间与链接，不搬运、不冒名。',
  },
  {
    key: 'R02',
    title: '评论就事论事',
    desc: '围绕事件本身发表观点，不做人身攻击，不扩散未经证实的隐私。',
  },
  {
    key: 'R03',
    title: '证据先于结论',
    desc: '发布判断前先自检依据，用「也许、可能」代替斩钉截铁的断言。',
  },
  {
    key: 'R04',
    title: '反对断章取义',
    desc: '截图请保留上下文，不裁剪出会误导他人的局部片段。',
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: '海角吃瓜到底是什么？',
    a: '你可以把它理解为「有规则、有边界的围观社区」：在这里围绕各类热点话题进行理性讨论，不制造对立，专注用清晰的方式讲清一件件事。',
  },
  {
    q: '新手海角吃瓜怎么玩最容易上手？',
    a: '建议先读完入门与规则两个合集，再顺着首页的索引频道挑一个感兴趣的方向订阅，跟着时间线完整看一个话题，会比零散围观快很多。',
  },
  {
    q: '围观时需要特别注意什么？',
    a: '时刻记得信源优先与证据先于结论。情绪上头时先深呼吸，跳出「争论输赢」的惯性，把注意力放回事实本身。',
  },
  {
    q: '这些攻略与教程会持续更新吗？',
    a: '会。编辑部会结合新老用户反馈定期补充，你可以把页面加入收藏，有新内容时到快讯时间线就能第一时间看到。',
  },
];